const state = {
  favorites: [],
  adverts: [],
  branches: []
}

export default state
